import FormHubungiKami from '../components/_homepage/formHubungiKami';
import 'typeface-montserrat';
import 'bootstrap/dist/css/bootstrap.css';
import '../assets/css/formHubungiKami.scss';

export default FormHubungiKami;
